<compass-stage-breadcrumbs></compass-stage-breadcrumbs>

<section>
    <div class="container">
        <compass-pois-accordion [setup]="accordionCatastro">
            <compass-catastro-menu [coordsCenter]='coordsCenter'></compass-catastro-menu>

        </compass-pois-accordion>
    </div>
</section>